import { useMemo } from 'react'
import useProjectTranslations from 'src/hooks/useProjectTranslations'

/**
 * This hook returns either the mikado TranslationProvider context, or calls the project's useProjectTranslations with the given namespace.
 * @param namespace
 * @param componentName
 * @returns {{t: (*|(function(*, *): *)), namespace: *, i18n: *}|{t: (*|(function(*, *): *)), namespace, i18n: (*|i18n)}}
 */
export default function useTranslations(namespace, componentName) {
    const { t: projectT, i18n: projectI18n } = useProjectTranslations(
        namespace,
        componentName
    )

    return useMemo(
        () => ({
            t: projectT,
            i18n: projectI18n,
            namespace: namespace,
        }),
        [projectT, projectI18n, namespace]
    )
}
